import config from "../config";

const apiUrl = config.apiUrl;

export const getHours = async () => {
  const response = await fetch(`${apiUrl}/schedules/default`);
  const data = await response.json();
  return data;
};
